import React from 'react';
import {Modal as BootstrapModal, ModalBody, ModalHeader} from 'reactstrap';
import {connect} from 'react-redux';
import {toastr} from 'react-redux-toastr';
import {SubmissionError} from 'redux-form';

import Modal from '../../../../shared/components//Modals/Modal.jsx';
import OfferAnswerForm, {name as formName} from '../../Forms/OfferAnswerForm/OfferAnswerForm.jsx';
import SubmitButton from '../../Forms/OfferAnswerForm/SubmitButton.jsx';

import api from '../../../../api.js';
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js';
import {isAdmin} from '../../../../shared/services/userService.js';

class OfferAnswerModal extends Modal {
  submit = async (_data) => {
    try {
      const data = {
        ..._data,
        offer: this.props.offer?.id,
        first_name: this.props.answer?.first_name ?? this.props.user?.firstname ?? null,
        tel: this.props.answer?.tel ?? this.props.user?.tel ?? null,
        last_name: this.props.answer?.last_name ?? this.props.user?.lastname ?? null,
        email: this.props.answer?.email ?? this.props.user?.email ?? null,
        cv_id: this.props.answer?.cv?.id ?? this.props.freelance?.cv?.id ?? null,
        type: this.props.answer?.user?.account_type ?? this.props.user?.account_type ?? null,        
      };
      if (this.props.isAdmin) {
        data['email'] = _data.user[0].email;
        data['user'] = _data.user[0].id;
        data['first_name'] = _data.user[0].firstname;
        data['last_name'] = _data.user[0].lastname;
        data['tel'] = _data.user[0].tel;
        data['type'] = _data.user[0].account_type;
        let freelance = await api.freelances.getOne({
          freelance: _data.user[0].freelance_id
        });
        data['cvId'] = freelance?.data?.cv ? freelance.data.cv?.id : null;
        await api.freelances.edit({
          date_available: data.availability_date,
          freelance: freelance.data?.id,
        });
      } else {
        await api.freelances.edit({
          date_available: data.availability_date,
          freelance: this.props.freelanceId,
        });
      }

      if ((this.props?.answer?.id ?? 0) !== 0) {
        data.offerAnswer = this.props.answer?.id;

        return await api.offers.answers.edit(data);
      } else {
        return await api.offers.answers.add(data)
      }
    } catch (e) {
      console.warn(e);
      throw new SubmissionError(e);
    }
  };

  onFormSuccess = (response) => {
    toastr.success('Votre candidature a bien été reçue par les managers Twineeds');
    if (this.props.onClose) {
      this.props.onClose({
        answer: response.data,
        offset: this.props.offset,
      });
    }
    this.props.closeModal();
  };

  onSubmitFail = (response) => {
    createOnSubmitFailHandler(formName);

    if (response.data) {
      for (let i = 0; i < response.data.errors.length; i++) {
        toastr.error(response.data.errors[i].message);
      }
    }
  };

  render() {
    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} size="lg" backdrop="static">
        <ModalHeader toggle={this.props.closeModal}>Candidater</ModalHeader>
        <ModalBody>
          <p>
            Attention votre profil doit être exhaustif pour que votre candidature soit pertinente!<br/>
            Seul Twineeds verra ces informations.
          </p>
          {
            !this.props.isAdmin && (this.props?.freelance?.cv?.id ?? 0) === 0 &&
            <div>Vous devez télécharger votre CV pour pouvoir répondre à une annonce</div>
          }
          <OfferAnswerForm
            isAdmin={this.props.isAdmin}
            enableReinitialize={true}
            initialValues={{
              ...this.props.answer,
              user: this.props.answer && this.props.answer.user ? [this.props.answer.user] : []
            }}
            onSubmit={this.submit}
            onSubmitSuccess={this.onFormSuccess}
            onSubmitFail={this.onSubmitFail}
          />
          <SubmitButton className="btn btn-primary my-3">
            Candidater
          </SubmitButton>
        </ModalBody>
      </BootstrapModal>
    );
  }
}

export default connect(
  (state) => ({
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse),
    freelanceId: state.currentUser?.freelance?.id ?? null
  })
)(OfferAnswerModal)